module.exports = require('portal/directives/NavBarCtrlProducer')